import React from 'react';
import { Mail, Instagram, Globe } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-brand-cream border-t border-brand-sand py-12" data-id="element-65">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-66">
        <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-2" data-id="element-67">
          🏋️ PILATES 360™
        </h3>
        <p className="text-gray-600 mb-8" data-id="element-68">
          Il sistema di pianificazione N°1 per insegnanti di Pilates.
        </p>

        <div className="flex flex-wrap justify-center gap-8 mb-12" data-id="element-69">
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-70">
            <Mail size={20} data-id="element-71" /> contatto@pilates360.com
          </a>
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-72">
            <Instagram size={20} data-id="element-73" /> @pilates360
          </a>
          <a href="#" className="flex items-center gap-2 text-brand-charcoal hover:text-brand-terracotta transition-colors" data-id="element-74">
            <Globe size={20} data-id="element-75" /> www.pilates360.com
          </a>
        </div>

        <div className="text-sm text-gray-500" data-id="element-76">
          © PILATES 360™ 2025 — Tutti i diritti riservati.
          <br data-id="element-77" />
          Vietata la riproduzione e ridistribuzione senza autorizzazione
          espressa.
        </div>
      </div>
    </footer>;
};